export default "__VITE_ASSET__DjP_Q0YK__"